import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { useThemeStore } from './stores/theme.store';
import './assets/main.css';

const app = createApp(App);
app.use(createPinia());
app.use(router);
// Instantiate now so the theme follows the system setting from the start, not only once
// the navigation (and its toggle) first renders.
useThemeStore();
app.mount('#app');
